// src/components/KnowledgeBase/loader/KBContentLoader.js
import React, { useState, useEffect } from "react";

const KBContentLoader = ({ category, subcategory }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadContent = async () => {
      setLoading(true);

      // 🔹 Minimal, safe normalization
      const cat = (category || "").toLowerCase().trim();
      const sub = (subcategory || "").toLowerCase().trim();

      try {
        let Component;

        if (["faq", "troubleshooting", "release-notes", "glossary"].includes(cat)) {
          // 🔹 Try main file first, then index.js fallback
          let mod;
          try {
            mod = await import(`../content/${cat}.js`);
          } catch {
            mod = await import(`../content/${cat}/index.js`);
          }
          Component = mod.default;
        } else {
          // 🔹 Primary path, then fallbacks (subcategory index, category index)
          let mod;
          try {
            mod = await import(`../content/${cat}/${sub}.js`);
          } catch (e1) {
            try {
              mod = await import(`../content/${cat}/${sub}/index.js`);
            } catch (e2) {
              mod = await import(`../content/${cat}/index.js`);
            }
          }
          Component = mod.default;
        }

        setContent(<Component />);
      } catch (error) {
        console.error(`Error loading content for ${category}/${subcategory}:`, error);
        setContent(
          <div className="content-error">
            <h6>Content Not Found</h6>
            <p>The requested content could not be loaded. Please try again later.</p>
          </div>
        );
      }
      
      setLoading(false);
    };
    
    loadContent();
  }, [category, subcategory]);
  
  if (loading) {
    return <div className="content-loading">Loading content...</div>;
  }
  
  return <div className="kb-content">{content}</div>;
};

export default KBContentLoader;
